import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Main from '../components/Main/Main';
import Logo from '../components/Preloader/SouravLogo';
import ScrollTop from '../components/ScrollTop/ScrollTop';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    console.log(isLoading, 'before')
    setTimeout(() => setIsLoading(false), [3000])
    console.log(isLoading, 'after')

  }, [isLoading])
  return (
    <div className="App">
      {isLoading ? <Logo /> :
        <>
          <Header />
          <Main />
          <Footer />
          <ScrollTop />
        </>
      }
    </div>
  );
}

export default App;
